<template>
  <sc-page-base :title="title" :loading="loading" class="page-integrations">

    <div class="columns">

      <div class="column app-filter">
        <new-app-filter />
      </div>

      <div class="column is-three-quarters">
        <div class="page-body">
          <app-list />
        </div>

        <modal />
      </div>
    </div>

  </sc-page-base>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { ScPageBase } from '@intelipost-js/secure-components';
import NewAppFilter from '../../components/app-filter/NewAppFilter.vue';
import Modal from '../../components/modal/Modal.vue';
import AppList from '../../components/app-list/AppList.vue';

const { mapState, mapActions, mapMutations } = createNamespacedHelpers(
  'integrations/integrationsHome',
);

export default {
  name: 'iplink-store',

  props: {
    appListSearch: {
      type: Object,
    },
  },

  data() {
    return {
      title: 'Integrações',
    };
  },

  computed: {
    ...mapState(['loading', 'appList']),
  },

  methods: {
    ...mapActions(['getAppList']),
    ...mapMutations(['setAppListFilter']),
  },

  mounted() {
    this.setAppListFilter(this.appListSearch);
    this.getAppList();
  },

  components: {
    ScPageBase,
    Modal,
    AppList,
    NewAppFilter,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {

  .sc-card--link {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .sc-card__content {
    min-height: 130px;
    flex-grow: 1;
  }

  .sc-card__content > div {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .app-filter {
    height: 90vh;
    position: sticky;
    top: 6rem;
  }

  .page-body {
    display: flex;
    flex-direction: column;
  }

}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations/IplinkStore.vue